<style lang="scss">
  @use "../../../assets/css/design-system/colors";
  button {
    padding: 0;
    margin: 0;
    border: none;
    background-color: white;
    cursor: pointer;

    &:disabled {
      opacity: 0.75;
      pointer-events: none;
    }

    &.left {
      border-radius: 10px 0 0 10px;
    }

    &.right {
      border-radius: 0 10px 10px 0;
    }

    &.light {
      @include colors.color(textWhite);
      @include colors.background-color(primary_50);

      &:focus {
        outline: 2px solid colors.get(primary_40);
      }

      &:active {
        @include colors.background-color(primary_80);
      }
    }

    &.dark {
      @include colors.color(primary_50);
      @include colors.background-color(textWhite);

      &:hover {
        @include colors.background-color(primary_5);
      }

      &:focus {
        outline: 2px solid colors.get(primary_40);
      }

      &:active {
        @include colors.background-color(primary_10);
      }

      &:disabled {
        @include colors.color(textDisabledGrey);
      }
    }
  }
</style>

<script>
  export let onclick; // action to take - button disabled if falsy
  export let side; // left or right
  export let mode = "dark"; // light or dark (referring to text)
  export let size = "large"; // small or large

  import IconScale from "../../atoms/IconScale.svelte";

  $: disabled = !onclick;
  $: iconSize = size === "large" ? "large" : "medium";
</script>

<button on:click={onclick} class="{side} {mode}" {disabled}>
  <IconScale class="fa-arrow-{side}" size={iconSize} />
</button>
